<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { setFontSize } from '@/util/datectZoom.js';

export default {
  name: '',
  data() {
    return {}
  },
  created() {
    // detectZoom()
    setFontSize()
    // this.fontSize()
  },
  methods: {
    fontSize() {
      //获取根元素 
      var docEl = document.documentElement;

      //获取宽度
      var width = docEl.getBoundingClientRect().width;
      console.log(width)
      //把宽度分成100份
      var rem = width / 100;
      console.log(rem)
      console.log(rem, 'rem');
      //设置根元素的fontSize
      docEl.style.fontSize = rem + 'px';

      // flexible.rem = win.rem = rem;
    },
  },

}
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

ul,
li {
  list-style: none;
  padding: 0;
  margin: 0;
}

i {
  font-style: normal
}

a {
  color: inherit;
  text-decoration: none;
}

a:hover {
  color: inherit;
  text-decoration: none;
}

a:visited {
  color: inherit;
  text-decoration: none;
}

a:active {
  color: inherit;
  text-decoration: none;
}

#app {
  min-width: 1349px;
  overflow: auto;
}

.img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
</style>
